export default {
  title: 'Import menu',
  master_title: 'Brand mode - Import menu',
  buttons: {
    import: 'Import',
  },
  toasts: {
    import: {
      pending:
        '⏳As import sometimes can be slow, we do it in the background. Please check the restaurant menu in a few minutes.',
    },
  },
};
